module.exports = "/static/assets/7ce197172287887ac173f361ca360f02.png";